import { render } from "./FieldOwnershipBadge.vue?vue&type=template&id=2abe5ee6"
import script from "./FieldOwnershipBadge.vue?vue&type=script&lang=js"
export * from "./FieldOwnershipBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__